import { redirect } from "@tanstack/react-router";

export const guardPasswordResetToken = (token: string | undefined): void => {
  if (!token) {
    redirect({ to: "/auth/password-reset/forgot-password", throw: true });
  }
};
